<template>
    <section class="hero-branding bg-cover" :style="bgImg" id="home">
        <div class="container-fluid container-fluid--cp-150">
            <div class="hero-branding">
                <div class="hero-content">
                    <h2 class="h1 hero-content-title">{{ $t("veritas.title") }}</h2>
                    <h6 class="hero-content-subtitle mt-20">{{ $t("veritas.subtitle") }}</h6>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                bgImg: {
                    backgroundImage: `url(${require('../../../assets/img/trustami/veritas.svg')})`
                },
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/variabls.scss';
    @import '../../../assets/scss/elements/hero-branding.scss';
</style>
